import React, { useState, useEffect, useRef } from 'react';
import { PrinterFetchAPI } from '../api/Printer';
import { MachinesFetchAPI } from '../api/Machines';

//print order
export const printData = async (dataprint, printers, test) => {
    let ip_print = "localhost"
    let machine = JSON.parse(localStorage.getItem('machine'));

    let arrayPrinters = [];
    printers.forEach((printer) => {
        if (printer.printer_type == "Tickets") {
            arrayPrinters.push(printer);
        } else if (test == true) {
            let newValue = { ...printer, printer_type: "Tickets" }
            arrayPrinters.push(newValue)
        }
    });

    let JsonImprimir = [{
        "Printers": arrayPrinters,
        "dataprint": {...dataprint, machine_code: machine.code, machine_type: machine.name_type_machine}
    }]

    try {
        const response = await PrinterFetchAPI.printData(ip_print, JsonImprimir)
    } catch (err) {
        console.log(err);
    }
}